import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#111111] px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Subtle blueprint/grid background in footer */}
      <div className="absolute inset-0 pointer-events-none opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="footer-grid" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#FFFFFF" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#footer-grid)" />
        </svg>
      </div>

      {/* Closing statement band */}
      <div className="relative border-b border-white/10 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-3xl sm:text-4xl font-bold text-white leading-tight">
            These roles aren't disappearing. <br />
            <span className="text-jeruel-primary">They are evolving.</span>
          </p>
          <p className="mt-6 text-xl text-gray-400 font-medium max-w-2xl mx-auto">
            Don't get caught unprepared. Download the report and get your blueprint for the next decade of maintenance and reliability.
          </p>
          <a 
            href="#download-form"
            className="inline-flex items-center gap-3 mt-10 px-10 py-5 rounded-xl bg-jeruel-primary hover:bg-jeruel-light text-white font-bold text-lg transition-all duration-300 hover:-translate-y-1 shadow-2xl hover:shadow-jeruel-primary/50"
          >
            Claim Your Free Report Now
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative py-8 flex flex-col sm:flex-row justify-center items-center gap-3 text-sm text-gray-500 font-medium">
        <span>© 2026 Jeruel Global (Learn 4.0 LLC)</span>
        <span className="hidden sm:inline text-gray-700">·</span>
        <a 
          href="https://jeruelglobal.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-white transition-colors duration-200 font-bold"
        >
          jeruelglobal.com
        </a>
      </div>
    </footer>
  );
};

export default Footer;